import React from 'react';
import { Box, Spinner, Text } from '@chakra-ui/react';

export const Loader: React.FC<{ message?: string }> = ({ message = 'Loading...' }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      width="100%"
    >
      <Spinner size="xl" />
      <Text mt={4}>{message}</Text>
    </Box>
  );
};
